import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-forms-confirmation-dialog',
  templateUrl: './delete-forms-confirmation-dialog.component.html',
  styleUrls: ['./delete-forms-confirmation-dialog.component.scss']
})
export class DeleteFormsConfirmationDialogComponent implements OnInit {

  IsAddtoArchive
  constructor(public dialogRef: MatDialogRef<DeleteFormsConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit() {
    this.IsAddtoArchive=this.data.IsAddtoArchive
  }

  onCloseClick() {
    this.dialogRef.close(false);
}


onConfirmDeleteClick() {
  this.dialogRef.close(true);
}

}
